import { ProgressAnimationOptions, ProgressType } from 'types';
import { progressReducer } from 'utils/embed/progress';
import { stringToViewport } from 'utils/placement';
import { ProgressAlignment, ProgressSize } from '../../../../types';
import { updateState } from '../../shared/mutations';
import { ProgressState, VideoTemplateStateContent } from '../../types';

// helper function to set the progress state from the shape used elsewhere
// in the app
// TODO this probably belongs somewhere else.  might want to make the distinction
// between which of the state utils are used internally and which are intended
// to be used externally.  as implementation progresses, the functions which
// need to be available externally should become clear
export function setProgressAnimationOptions(
  state: VideoTemplateStateContent,
  progress: ProgressAnimationOptions,
) {
  if (!progress) return state;
  return updateState(state, {
    progress: stringToViewport(progress),
  });
}

export function setProgressAlignment(
  state: VideoTemplateStateContent,
  alignment: ProgressAlignment,
): VideoTemplateStateContent {
  return updateState(state, {
    progress: progressReducer(state.progress, {
      type: 'UPDATE_POSITION',
      payload: alignment,
      meta: state.canvas,
    }),
  });
}

export function setProgressSize(
  state: VideoTemplateStateContent,
  size: ProgressSize,
): VideoTemplateStateContent {
  return updateState(state, {
    progress: progressReducer(state.progress, {
      type: 'UPDATE_SIZE',
      payload: size,
      meta: state.canvas,
    }),
  });
}

export function setProgressType(
  state: VideoTemplateStateContent,
  style: ProgressType | null,
): VideoTemplateStateContent {
  return updateState(state, {
    progress: progressReducer(state.progress, {
      type: 'UPDATE_TYPE',
      payload: style,
      meta: state.canvas,
    }),
  });
}

export function setProgress(
  state: VideoTemplateStateContent,
  opts: Partial<ProgressState>,
): VideoTemplateStateContent {
  if (!opts) return state;

  return updateState(state, {
    progress: opts,
  });
}
